import { Component, Injector, OnInit } from "@angular/core";
import { Promo } from "src/app/models/promo";
import { PromoService } from "src/app/services/promo.service";
import { Router, ActivatedRoute } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-detail-promo",
  templateUrl: "./detail-promo.component.html",
  styleUrls: ["./detail-promo.component.css"],
})
export class DetailPromoComponent implements OnInit {
  public promo: Promo;
  public isLoadingPromo = true;
  viewContent: any;

  constructor(
    public promoService: PromoService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.getPromoDetail();
  }

  getPromoDetail() {
    const promoId = this.route.snapshot.paramMap.get("id");

    this.promo = this.promoService.getPromoDetail(
      promoId,
      (data) => {
        this.promo = data;
        this.viewContent = this.sanitizer.bypassSecurityTrustHtml(
          this.promo.description
        );
      },
      (err) => {
        console.log(err);
      }
    );
  }
}
